module.exports = __webpack_public_path__ + "img/arrow-down.7e41a876.svg";